import * as Yup from "yup";

export const validateSubscriptionForm = Yup.object().shape({
  userId: Yup.string().optional(),
  firstName: Yup.string()
    .min(2, "First name too short")
    .max(50, "First name too long")
    .required("First name is required"),
  lastName: Yup.string()
    .min(2, "Last name too short")
    .max(50, "Last name too long")
    .required("Last name is required"),
  middleName: Yup.string()
    .min(2, "Middle name too short")
    .max(50, "Middle name too long")
    .optional()
    .nullable(),
  address: Yup.object().shape({
    streetName: Yup.string().optional().nullable(),
    zipCode: Yup.string().optional().nullable(),
    city: Yup.string().optional().nullable(),
    state: Yup.string().optional().nullable(),
    country: Yup.string().optional().nullable(),
    county: Yup.string().optional().nullable(),
  }),
});

export const updatePaymentMethodValidateForm = Yup.object().shape({
  userId: Yup.string().optional(),
  address: Yup.object().shape({
    streetName: Yup.string().optional().nullable(),
    zipCode: Yup.string().optional().nullable(),
    city: Yup.string().optional().nullable(),
    state: Yup.string().optional().nullable(),
    country: Yup.string().optional().nullable(),
    county: Yup.string().optional().nullable(),
  }),
});

export const cancelPaymentMethodValidationForm = Yup.object().shape({
  userId: Yup.string().required(),
  cancellationReason: Yup.string().required(),
});
